import React, { FC } from 'react'

import dayjs from 'dayjs'

import Box from '@mui/material/Box'
import { Alert } from '@app/types/alert'
import { AppIcon } from '@app/components/AppIcon'
import { useTimeController } from '@app/hooks/contexts/timeController/TimeControllerContext'

import theme from '../../../../../../../theme'
import AppAlertBase from '../../../../../../../components/AppAlertBase'
import AlertEventTime from '../../../../../../../components/AlertEventTime'

interface SidebarNewPatientAlertProps {
	readonly alert: Alert
}

const SidebarNewPatientAlert: FC<SidebarNewPatientAlertProps> = ({
	alert,
}: SidebarNewPatientAlertProps) => {
	const {
		formatters: { df },
	} = useTimeController()
	const eventTime = df(alert.op?.addedTimestamp)
	const startOfService = alert.data?.start_service
		? df(dayjs(alert.data?.start_service).startOf('day'))
		: ''

	return (
		<>
			<AppAlertBase
				iconSlot={
					<AppIcon type={'newPatientSmile'} width={31} height={31} />
				}
				iconBoxSx={{
					bgcolor: theme.palette.secondary.light,
					height: 'auto',
				}}
				title={alert.data?.alert_description || ''}
				subTitle={`Joined: ${startOfService}`}
			/>

			<Box
				sx={{
					display: 'flex',
					'>p:first-of-type': {
						mr: 2,
					},
				}}
			>
				<AlertEventTime eventTime={eventTime} />
			</Box>
		</>
	)
}

export default SidebarNewPatientAlert
